import React from "react"
import FeaturedItem from "./FeaturedItem"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"
import paths from "../../constants/paths"

const Div = styled.div`
  > div:nth-child(even) {
    background: var(--brand-color-maroon);
  }
  > div:nth-child(odd) {
    background: var(--brand-color-green);
  }
`;

export default function FeaturedItems() {
  return (
    <Div className="featured-items pure-g">
      <FeaturedItem
        title="View Weddings"
        image={<StaticImage alt="Seattle Wedding Photography in a hot air baloon in Snohomish Washington" src="../../images/theme/Seattle-Wedding-Photographer-Snohomish-Ballooning-Hot-air-balloon-ceremony.jpg" width={600} />}
        linkUrl={paths.portfolioWeddings.url} />
      <FeaturedItem
        title="View Couples"
        image={<StaticImage alt="Ross Lake adventure session in Pacific Northwest Elopement" src="../../images-galleries/portfolios/couples/Ross-Lake-Adventure-Session-PNW-Elopement-Photographer-NorthCascades-2.jpg" width={600} />}
        linkUrl={paths.portfolioCouples.url} />
    </Div>
  )
}
